import { IMAGES } from "@/config/site";

export const Logo = ({ size = "h-14 w-auto", wordmark = true }) => (
  <span className="flex items-center gap-3">
    <img src={IMAGES.logo.small} alt={IMAGES.logo.alt} className={`${size} drop-shadow-[0_4px_12px_rgba(0,0,0,0.25)]`} width="60" height="56" />
    {wordmark && (
      <span className="hidden flex-col leading-none sm:flex">
        <span className="font-display text-[13px] font-extrabold tracking-[0.14em] text-paper">FIRST RESPONDERS</span>
        <span className="mt-1 font-display text-[10px] font-semibold tracking-[0.42em] text-gold">FOUNDATION</span>
      </span>
    )}
  </span>
);
